import { dateUtility } from "~/EasyProjectsCommon/Dates/DateUtility";

export const formPeriodPayload = (items: Date[]) => {
    let periods = [];
    const today = dateUtility.today();

    if (items.find(x => dateUtility.compareDates(x, today) === false)) {
        periods.push("past");
    }

    if (items.find(x => dateUtility.compareDates(x, today) === 0)) {
        periods.push("today");
    }

    if (items.find(x => dateUtility.compareDates(x, today) === true)) {
        periods.push("future");
    }

    return periods;
};
